import { useBookingEditText } from "../text";
import { createTypographyHelper } from '../../../../utils/typography';
import { cn } from "../../../../utils/classnames";

const CounterCard = ({
  title,
  subtitle,
  value,
  onIncrement,
  onDecrement,
  disableIncrement = false,
  titleClass = '',
  subtitleClass = '',
  valueClass = ''
}) => {
  const { language } = useBookingEditText();
  const getTypographyClass = createTypographyHelper(language);
  const isZero = value === 0;

  return (
    <div className="tw:rounded-[5px] tw:border tw:border-[#e8e8e8] tw:bg-white tw:px-4 tw:py-5 tw:font-hanken-grotesk">
      <div className="tw:flex tw:items-center tw:justify-between tw:w-full">
        <div>
          <div className={`tw:mb-0 tw:text-[#282828] ${titleClass}`}>
            {title}
          </div>
          <div className={`tw:mb-0 tw:text-[#8d8d8d] ${subtitleClass}`}>
            {subtitle}
          </div>
        </div>
        <div className="tw:flex tw:items-center tw:gap-2">
          <button
            type="button"
            onClick={onDecrement}
            disabled={isZero}
            className="tw:h-[32px] tw:w-[32px] tw:font-hanken-grotesk"
          >
            <div className={cn(`tw:w-full tw:h-full tw:flex tw:items-center tw:justify-center tw:rounded-full tw:border tw:transition-colors tw:border-[#dbbe78] ${isZero
              ? "tw:bg-white tw:text-[#a7a7a7] tw:opacity-40 tw:cursor-not-allowed"
              : "tw:bg-[#f9edd3] tw:text-[#282828] hover:tw:bg-gray-50"
              } ${getTypographyClass(14)}`)}>
              -
            </div>
          </button>
          <span className={`tw:min-w-[20px] tw:text-center tw:text-[#282828] ${valueClass}`}>{value}</span>
          <button
            type="button"
            onClick={onIncrement}
            disabled={disableIncrement}
            className="tw:h-[32px] tw:w-[32px] tw:font-hanken-grotesk"
          >
            <div className={cn(`tw:w-full tw:h-full tw:flex tw:items-center tw:justify-center tw:rounded-full tw:border tw:transition-colors tw:border-[#dbbe78] ${disableIncrement
              ? "tw:bg-white tw:text-[#a7a7a7] tw:opacity-40 tw:cursor-not-allowed"
              : "tw:bg-[#f9edd3] tw:text-[#282828] hover:tw:bg-[#f5e6bc]"
              } ${getTypographyClass(14)}`)}>
              +
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CounterCard;
